const NewSellerIcon = ({width = '16', height = '16'}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <g clipPath="url(#a)">
        <path
          fill="#212124"
          d="M16 5.539a.61.61 0 0 0-.023-.17l-1.104-3.862a1.237 1.237 0 0 0-1.181-.892H2.305a1.236 1.236 0 0 0-1.18.892L.02 5.37a.607.607 0 0 0-.024.17v1.23a3.077 3.077 0 0 0 1.231 2.463v4.923a1.23 1.23 0 0 0 1.231 1.231h11.079a1.231 1.231 0 0 0 1.23-1.23V9.231A3.078 3.078 0 0 0 16 6.77V5.539ZM2.305 1.846h11.387l.878 3.077H1.43l.876-3.077Zm3.847 4.308h3.693v.616a1.846 1.846 0 0 1-3.693 0v-.616Zm-1.231 0v.616a1.846 1.846 0 0 1-3.693 0v-.616h3.693Zm8.617 8.001H2.459v-4.37a3.077 3.077 0 0 0 3.077-1.17 3.077 3.077 0 0 0 4.924.001 3.078 3.078 0 0 0 3.078 1.17v4.37Zm-.616-5.539a1.846 1.846 0 0 1-1.846-1.846v-.616h3.693v.616a1.846 1.846 0 0 1-1.847 1.846Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NewSellerIcon;
